import { Box, Button } from '@mui/material'
import {styled} from '@mui/material'
import { useEffect } from 'react';
import { useInterestedFilterStore } from 'src/stores/InterestedStore';


// 필터 버튼 스타일
const FilterButton = styled(Button)(({ theme }) => ({
    margin: "5px",
    borderRadius: "20px",
    '&.selected': {
    backgroundColor: "rgba(57, 185, 91, 0.05)", // #39B95B의 5% 투명도 적용
    color: 'rgba(6, 121, 155, 1)',                        // 테두리와 글씨 색상
    border: '1px solid rgba(6, 121, 155, 1)'         // 테두리 색상
    },
    '&.unselected': {
    backgroundColor: 'white',
    color: 'black',
    border: `1.5px solid ${theme.palette.grey[400]}`,
    },
}));

const TitleWrapper = styled('span')(({theme})=>({
    fontSize:'16px',
    fontWeight:500,
}))

const ToggleTagEdu_Level = () => {
    const temp_edu_level = useInterestedFilterStore((state)=>state.temp_edu_level)
    const temp_highschool_type = useInterestedFilterStore((state)=>state.temp_highschool_type)
    const toggleFilter = useInterestedFilterStore((state)=>state.toggleFilter)
    const syncField = useInterestedFilterStore((state)=>state.syncField)
    useEffect(()=>{
        syncField('edu_level','temp','base')
        syncField('highschool_type','temp','base')
    },[])
    const mapLevel: Record<number,string>={
        0: '전체',
        1 : '고등학교',
        2 : '전문대학교',
        3 : '대학교',
        4 : '기타홍보'
        }
        const mapHighSchool: Record<number,string>={
        0 : '전체',
        1 : '일반고',
        2 : '자사고',
        3 : '특목고',
        4 : '특성화고'
        }

  return (
    <>
        <TitleWrapper>
            학교
        </TitleWrapper>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: "5px", mb: 2 }}>
            {[0, 1, 2, 3, 4].map(level => (
            <FilterButton
                key={level}
                onClick={() => toggleFilter("temp_edu_level", level, 0)}
                className={temp_edu_level.includes(level) ? "selected" : "unselected"}
            >
                {mapLevel[level]}
            </FilterButton>
            ))}
        </Box>
        {(temp_edu_level.includes(0) || temp_edu_level.includes(1)) && (
            <>
                <TitleWrapper>
                고등학교
                </TitleWrapper>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: "5px", mb: 2 }}>
                {[0, 1, 2, 3, 4].map(type => (
                    <FilterButton
                    key={type}
                    onClick={() => toggleFilter("temp_highschool_type", type, 0)}
                    className={temp_highschool_type.includes(type) ? "selected" : "unselected"}
                    >
                    {mapHighSchool[type]}
                    </FilterButton>
                ))}
                </Box>
            </>
        )}
    </>
  )
}

export default ToggleTagEdu_Level